import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap, tap } from 'rxjs/operators';

import { GlobalsService } from '../_services/globals.service';

@Injectable()
export class AdminService {

  constructor(private gs: GlobalsService, private http: HttpClient) {}

  private formOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/x-www-form-urlencoded'
      }),
      withCredentials: false
    };
  }

  public syncKcDbUsers(table: any[]): void {
    this.getKcUsers().pipe(
      switchMap(kcUsers =>
        this.http.post<any>(
          this.gs.getRestUrl() + '/api/keycloak/syncusers',
          kcUsers,
          { withCredentials: false }
        )
      ),
      switchMap(() =>
        this.http.get<any[]>(
          this.gs.getRestUrl() + '/api/keycloak/getusers',
          { withCredentials: false }
        )
      ),
      tap((users: any[]) => {
        for (const u of users || []) {
          table.push({ id: u.id, username: u.username });
        }
      })
    ).subscribe({
      error: (e: any) => console.log(e)
    });
  }

  public deleteusermid(id: string): Observable<any> {
    const body = new HttpParams().set('id', id).toString();

    return this.http.post<any>(
      this.gs.getRestUrl() + '/api/keycloak/deleteusermid',
      body,
      this.formOptions()
    );
  }

  public addusermid(users_id: string, ob_mid: string): Observable<any> {
    const body = new HttpParams()
      .set('users_id', users_id)
      .set('ob_mid', ob_mid)
      .toString();

    return this.http.post<any>(
      this.gs.getRestUrl() + '/api/keycloak/addusermid',
      body,
      this.formOptions()
    );
  }

  public getAvailableMid(): Observable<any> {
    return this.http.get<any>(
      this.gs.getRestUrl() + '/api/keycloak/getmidlist',
      { withCredentials: false }
    );
  }

  public getUsersMid(users_id: number): Observable<any> {
    const params = new HttpParams().set('users_id', String(users_id));

    return this.http.get<any>(
      this.gs.getRestUrl() + '/api/keycloak/getusermid',
      { withCredentials: false, params }
    );
  }

  private getKcUsers(): Observable<any> {
    return this.http.get<any>(
      this.gs.getRestUrl() + '/api/keycloak/kcusers',
      { withCredentials: false }
    );
  }
}